import { NomadDB } from '~/db/NomadDB.js';
import type { CoachingStatSchema } from '@/types/schema';

export const getCoachingStatsService = (db: NomadDB) => {
  const get = async (params: any): Promise<CoachingStatSchema> => {
    const coachingStat = await db.coachingStats.get(params);
    return coachingStat;
  };

  const put = async (params: any): Promise<any> => {
    return await db.coachingStats.put(params);
  };

  const findByDates = async (
    dates: string[]
  ): Promise<CoachingStatSchema[]> => {
    return await db.coachingStats
      .where('historyDateUTC')
      .anyOf(dates)
      .toArray();
  };

  const findLastTotal = async () => {
    const items = await db.coachingStats
      .where({ total: 1 })
      .reverse()
      .sortBy('historyDateUTC');
    if (!items.length) return null;
    return items[0];
  };

  const findLastByLb = async (librartyBookId: string) => {
    const items = await db.coachingStats
      .where(['appId+total'])
      .anyOf([[librartyBookId, 0]])
      .reverse()
      .sortBy('historyDateUTC');
    if (!items.length) return null;
    return items[0];
  };

  return {
    get,
    put,
    findByDates,
    findLastTotal,
    findLastByLb,
  };
};
